import { useNavigate, useParams } from 'react-router-dom'
import { Link } from '~/components/common/Link'

interface Props {
  children: React.ReactNode
  href?: string
}

export function A({ children, href }: Props) {
  const navigate = useNavigate()
  const { workspaceUuid } = useParams<{ workspaceUuid: string }>()

  // Check if this is a task link (e.g., /c/{uuid}?task_id={taskId})
  const taskLinkMatch = href && href.match(/^\/c\/([^/?]+)\?task_id=(.+)$/)

  const handleTaskLinkClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (taskLinkMatch) {
      const [, conversationUuid, taskId] = taskLinkMatch
      // Navigate to conversation with task_id query parameter
      const conversationUrl = `/w/${workspaceUuid}/c/${conversationUuid}`
      navigate(`${conversationUrl}?task_id=${taskId}`)
    }
  }

  // For task links, use in-app navigation with query parameters
  if (taskLinkMatch) {
    return (
      <a
        href={href}
        onClick={handleTaskLinkClick}
        className='text-blue-500 dark:text-blue-300 cursor-pointer hover:underline'
      >
        {children}
      </a>
    )
  }

  // For external links, keep the original behavior (open in new tab)
  return (
    <Link href={href!} target='_blank' className='text-blue-500 dark:text-blue-300'>
      {children}
    </Link>
  )
}

// Export with lowercase name for markdown compatibility
export const a = A
